/* eslint-disable max-len */
import Api from './axios';
import { createCounterTopUrl } from '../utils/createCounterTopUrl';
import { Utils, QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS } from '../utils/urlUtils';

export const getPageData = (omsid) => {
  const path = `countertops/pagedata/${omsid}`;
  return Api().get(createCounterTopUrl(path))
    .then((response) => response.data)
    .catch((error) => { throw error; });
};

export const getConfigSelections = (availableSkus, selectedSku, store) => {

  const { customBaseUrl, partnerProductId } = window.injectedConfiguratorSettings;
  const baseConfigurationIdForSelections = Utils.getParameterByName(QUERY_PARAM_BASE_CONFIGURATION_ID_FOR_SELECTIONS);

  const url = `${customBaseUrl}/countertops/api/configuratoroptions/${store}/${selectedSku}?availableSkus=${availableSkus}&configurationIdForSelections=${baseConfigurationIdForSelections}&productId=${partnerProductId}`;

  return Api().get(url)
    .then((response) => response.data)
    .catch((error) => { throw error; });
};

export const createConfigId = (productId, selections, additionalDetails, mainImageUrl, store) => {
  const { customBaseUrl } = window.injectedConfiguratorSettings;
  const { siteId } = window.injectedConfiguratorSettings;

  const apiPayload = {
    siteId, productId, selections, additionalDetails, mainImageUrl, storeId: store
  };

  const url = `${customBaseUrl}/countertops/api/createconfiguration`;
  return Api().post(url, apiPayload)
    .then((response) => response.data)
    .catch((error) => { throw error; });

};
